import { Stack } from '@mui/material';
import { FieldEditorSection } from 'components/FieldEditor/types/FieldEditorSection';
import React from 'react';

import { CheckboxWithLabel } from '../CheckboxWithLabel';
import { InputArea } from '../InputArea';

export function SortableMeta({ field, setField }: FieldEditorSection) {
  const meta = field.meta || {};

  const updateMeta = (updates: any) => {
    setField({
      ...field,
      meta: {
        ...meta,
        ...updates,
      },
    });
  };

  const sortableMeta: any = meta['blackframe.sortable'] || {};

  return (
    <InputArea name="Meta" description="Meta configuration for sortable fields">
      <Stack gap={3}>
        <CheckboxWithLabel
          label="Sort Ascending"
          checked={sortableMeta?.sortAsc || false}
          setChecked={(v) => {
            updateMeta({
              'blackframe.sortable': {
                ...sortableMeta,
                sortAsc: v,
              },
            });
          }}
        />
      </Stack>
    </InputArea>
  );
}
